import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { states } from 'constants/DropdownsValues';
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
// import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';
// import Divider from 'components/Divider';
import styles from './Rtiles.scss';// to import local scss fle

class Rtiles extends Component {
  static propTypes = {
    item: PropTypes.shape(),
  };
  static defaultProps = {
    item: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  render() {
    const { item } = this.props;

    let athleteHaveProfileImage = false;
    if (item.get('sa_image') !== undefined) {
      athleteHaveProfileImage = true;
    }
    const sport = item.get('sports');
    const position = sport.get('FOOTBALL');
    return (
      <div className={styles.container}>
        <div className={styles.tile}>
          <Link to={`/athlete/${item.get('id')}`} target="_blank">
            <div>
              <img
                className={styles.colgeIcon}
                src={athleteHaveProfileImage === true ? //eslint-disable-line
                       `https://s3.amazonaws.com/myrbimagesdev/${item.get('sa_image')}` : //eslint-disable-line
                       'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png'}
                alt="athlete-icon"
              />
              <div className={styles.collegeName}>{item.get('fullname')}</div>
              {/*eslint-disable*/}
              <div className={styles.sportName}>
                {position.get('primary_offensive_position_pref') !== undefined ?
                  <span>{position.get('primary_offensive_position_pref')}</span> : ''}
                {position.get('primary_defensive_position_pref') !== undefined ?
                  <span>,&nbsp;&nbsp;{position.get('primary_defensive_position_pref')}</span> : ''}
                {position.get('secondary_offensive_position_pref') !== undefined ?
                  <span>,&nbsp;{position.get('secondary_offensive_position_pref')}</span> : ''}&nbsp;
                {position.get('secondary_defensive_position_pref') !== undefined ?
                  <span>,&nbsp;{position.get('secondary_defensive_position_pref')}</span> : ''}
              </div>
              <div className={styles.userNameIcon}>
                <span >
                  <div className={styles.schoolName}>
                    {item.get('school')}
                  </div>
                  <div className={styles.cityName}>
                    {item.get('city')}, {states[item.get('sa_state')]}
                  </div>
                  <div className={styles.lightText}>
                    {item.get('academic').get('year_of_graduation')},&nbsp;&nbsp;{item.getIn(['academic', 'gpa'])}
                  </div>
                </span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    );
  }
}

export default Rtiles;



// WEBPACK FOOTER //
// ./src/components/CoachDashboardView/components/DivisionBasedStudent/components/Tiles/Rtiles.js